import {
  SeaAllFilterField,
  TagAction,
} from '@aibees/elephant/components/see-all-popup';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { Technologies } from '../insight/components/technologies';
import { FinancesInfo } from './components/finances-info';
import { IndustryInfo } from './components/industry-info';
import * as Styled from './styles';
import * as SX from './sx';
import type { OverviewProps as Props } from './types';

export const Overview = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper className={classnames('Overview', className)} sx={SX.root}>
      <Stack sx={SX.content} gap={1.5}>
        <IndustryInfo
          config={{
            actions: [
              TagAction.INCLUDE_IN_EXISTING_SEARCH,
              TagAction.INCLUDE_IN_NEW_SEARCH,
              TagAction.EXCLUDE_IN_EXISTING_SEARCH,
              TagAction.EXCLUDE_IN_NEW_SEARCH,
            ],
            field: SeaAllFilterField.industry,
            placeholder: 'Search Industry Tags',
          }}
        />
        <FinancesInfo />
        <Technologies
          config={{
            actions: [
              TagAction.INCLUDE_IN_EXISTING_SEARCH,
              TagAction.INCLUDE_IN_NEW_SEARCH,
              TagAction.EXCLUDE_IN_EXISTING_SEARCH,
              TagAction.EXCLUDE_IN_NEW_SEARCH,
            ],
            field: SeaAllFilterField.technologies,
            placeholder: 'Search Technology Tags',
          }}
        />
      </Stack>
    </Styled.Wrapper>
  );
});

Overview.displayName = 'Overview';
